module.exports = __webpack_public_path__ + "static/media/img_advantage.7899f05e.jpg";